module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-mobile-1.2ba94a51.png";